import { render, staticRenderFns } from "./CommissionsShow.vue?vue&type=template&id=6116fa18&"
import script from "./CommissionsShow.vue?vue&type=script&lang=js&"
export * from "./CommissionsShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports